import { createDraftSafeSelector } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

const selectSelf = (state: RootState) => state.buyer;

const viewFullEnabled = createDraftSafeSelector(selectSelf, (state) => state.viewLevel === 'full');

const viewLevelSelector = createDraftSafeSelector(selectSelf, (state) => state.viewLevel);
const circaActiveSelector = createDraftSafeSelector(selectSelf, (state) => state.circaActive);

const tendersPermissionsSelector = createDraftSafeSelector(selectSelf, (state) => {
  return state.tendersPermissions;
});

const isBetaBuyerSelector = createDraftSafeSelector(
  selectSelf,
  (state) => state.featureToggles.length > 0,
);

const isDevBuyerSelector = createDraftSafeSelector(selectSelf, (state) =>
  state.featureToggles.includes('dev_buyer'),
);

const buyerViewPreferences = createDraftSafeSelector(selectSelf, (state) => state.viewPreferences);

const profilePageSelector = createDraftSafeSelector(selectSelf, (state) => {
  const { firstName, lastName, businessLicense, company, email, phone, taxIdNumber } = state;

  return { firstName, lastName, businessLicense, company, email, phone, taxIdNumber };
});

const portalPermissionsSelector = createDraftSafeSelector(
  viewLevelSelector,
  circaActiveSelector,
  isDevBuyerSelector,
  (viewLevel, circaActive, isDevBuyer) => {
    if (!viewLevel) {
      return {
        status: 'pending',
        auctions: false,
        tenders: false,
        hampton: false,
      };
    }

    return {
      status: 'fulfilled',
      auctions: true,
      tenders: circaActive ?? false,
      hampton: true,
    };
  },
);

export const buyerSelectors = {
  viewFullEnabled,
  portalPermissionsSelector,
  tendersPermissionsSelector,
  isBetaBuyerSelector,
  isDevBuyerSelector,
  profilePageSelector,
  buyerViewPreferences,
};
